import { render, staticRenderFns } from "./WhatsappMessagePreview.vue?vue&type=template&id=71982d52&scoped=true"
import script from "./WhatsappMessagePreview.vue?vue&type=script&lang=js"
export * from "./WhatsappMessagePreview.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessagePreview.vue?vue&type=style&index=0&id=71982d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71982d52",
  null
  
)

export default component.exports